module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAcklEQVRYR2NkGGDAOMD2M4w6YHCEwP/dSvUMDAwN9EwPjK73wJ4HE6MOgITAfwf6RsF9R3gU0NNidLsGRy4YDYEBD4EBzwWjBdGAh8CAJ8JRB4yGADQX0DUgGF3vNY62iAZdCAxcGqCrzWiWjTbJBjwEAKAWNiEPAc7sAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/closedrawer.png
// module id = DS2s
// module chunks = 16